"use client";

import { ArrowLeft, SearchX } from "lucide-react";
import Link from "next/link";
import { usePathname } from "next/navigation";

import { DEFAULT_POST_LANGUAGE } from "@/lib/post-language";
import { getFeedPath, parsePostLanguageFromPathname } from "@/lib/post-routes";
import { getPublicVocabulary } from "@/lib/public-vocabulary";
import {
  PUBLIC_STATUS_ACTION_CLASS,
  PublicStatusPanel,
} from "@/components/public-status-panel";

// not-found.tsx non riceve params: la lingua si deduce dal primo segmento del
// path (una URL senza lingua, tipo /pippo, ricade sull'italiano).
export function PublicNotFoundView() {
  const pathname = usePathname();
  const language = parsePostLanguageFromPathname(pathname ?? "") ?? DEFAULT_POST_LANGUAGE;
  const copy = getPublicVocabulary(language).status;

  return (
    <PublicStatusPanel
      eyebrow={copy.notFoundEyebrow}
      icon={<SearchX className="h-6 w-6" aria-hidden="true" />}
      title={copy.notFoundTitle}
      description={copy.notFoundDescription}
    >
      <Link href={getFeedPath(language)} className={PUBLIC_STATUS_ACTION_CLASS}>
        <ArrowLeft className="h-4 w-4" aria-hidden="true" />
        {copy.backToFeed}
      </Link>
    </PublicStatusPanel>
  );
}
